import React from 'react';
import Icon from '@mdi/react';
import {
    mdiCashMultiple,
    mdiCashRefund,
    mdiCreationOutline,
    mdiLinkVariant,
    mdiPrinter,
    mdiTagOutline,
} from '@mdi/js';
import { Tooltip } from '../../base';
import * as S from '../statement-details.styles';

export type StatementHeaderProps = {
    patientName?: string;
    externalId?: string;
    showActions: boolean;
    onCopyUrl: () => void;
    onPrint: () => void;
    onRecordDiscount: () => void;
    onRecordRefund: () => void;
    onRecordPayment: () => void;
    aiTooltipTitle: string;
    isAiChecking: boolean;
    onTalkToAiClick: () => void;
};

export const StatementHeader: React.FC<StatementHeaderProps> = ({
    patientName,
    externalId,
    showActions,
    onCopyUrl,
    onPrint,
    onRecordDiscount,
    onRecordRefund,
    onRecordPayment,
    aiTooltipTitle,
    isAiChecking,
    onTalkToAiClick,
}) => (
    <S.HeaderRow>
        <S.HeaderTitleBlock>
            <S.PageTitle>Patient Statement</S.PageTitle>
            <S.PageSubtitle>
                Account overview
                {patientName ? ` · ${patientName}` : ''}
                {externalId ? ` · External ID ${externalId}` : ''}
            </S.PageSubtitle>
        </S.HeaderTitleBlock>
        <S.StatementButtonGroup>
            <S.HeaderGhostButton type="button" variant="unstyled" onClick={onCopyUrl}>
                <Icon path={mdiLinkVariant} size={0.75} />
                Copy URL
            </S.HeaderGhostButton>
            <S.HeaderOutlinedButton type="button" variant="unstyled" onClick={onPrint}>
                <Icon path={mdiPrinter} size={0.75} />
                Print
            </S.HeaderOutlinedButton>
            {showActions && (
                <>
                    <S.HeaderOutlinedButton type="button" variant="unstyled" onClick={onRecordDiscount}>
                        <Icon path={mdiTagOutline} size={0.75} />
                        Set claim discount
                    </S.HeaderOutlinedButton>
                    <S.HeaderOutlinedButton type="button" variant="unstyled" onClick={onRecordRefund}>
                        <Icon path={mdiCashRefund} size={0.75} />
                        Record refund
                    </S.HeaderOutlinedButton>
                    <S.HeaderPrimaryButton type="button" variant="unstyled" onClick={onRecordPayment}>
                        <Icon path={mdiCashMultiple} size={0.75} />
                        Record payment
                    </S.HeaderPrimaryButton>
                </>
            )}
            <S.AskButtonWrapper>
                <Tooltip direction="top" variant="dark" title={<span>{aiTooltipTitle}</span>}>
                    <S.CustomAIButton onClick={onTalkToAiClick} disabled={isAiChecking}>
                        <Icon path={mdiCreationOutline} size="16px" />
                        Talk to AI
                    </S.CustomAIButton>
                </Tooltip>
            </S.AskButtonWrapper>
        </S.StatementButtonGroup>
    </S.HeaderRow>
);
